import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        tabs: {
            height: theme.spacing(4.5),
            minHeight: `${theme.spacing(4.5)} !important`,
        },
    }
})

export default useStyles
